module.exports = {
	fichasData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV': require('./../assets/Fichas/ActualizacionJunio/220603brochureescapehev2022.pdf'),
				'MUSTANG MACH 1': require('./../assets/Fichas/Nuevas/brochure_mustang_mach1_v1.pdf'),
				'MUSTANG GT PREMIUM': require('./../assets/Fichas/Nuevas/220428 brochure mustang.pdf'),
				'ESCAPE ECOBOOST': require('./../assets/Fichas/2023_05_12/ecoboost.pdf'),
				'ESCAPE SE 4X2 FHEV': require('./../assets/Fichas/ActualizacionJunio/220603brochureescapehev2022.pdf'),
				'ESCAPE SEL 4X2 FHEV': require('./../assets/Fichas/ActualizacionJunio/220603brochureescapehev2022.pdf'),
				'BRONCO SPORT WILDTRAK': require('./../assets/Fichas/ActualizacionJunio/220603brochurebronco.pdf'),
				'BRONCO SPORT BIG BEND': require('./../assets/Fichas/ActualizacionJunio/220603brochurebronco.pdf'),
				'BRONCO SPORT OUTER BANKS': require('./../assets/Fichas/BRONCO_OB/fco-brochure-bronco-sport.pdf'),
				'EDGE SEL': require('./../assets/Fichas/2023_05_12/edge_sel.pdf'),
				'EDGE ST': require('./../assets/Fichas/2023_05_12/edge_st.pdf'),
				'EXPLORER XLT': require('./../assets/Fichas/2023_05_12/explorer.pdf'),
				'EXPLORER LIMITED': require('./../assets/Fichas/2023_05_12/explorer.pdf'),
				'EXPLORER ST': require('./../assets/Fichas/2023_05_12/explorer_st.pdf'),
				'EXPEDITION LIMITED': require('./../assets/Fichas/12. EXPEDITION LIMITED/fco-expedition-ficha-tecnica.pdf'),
				'RANGER XL': require('./../assets/Fichas/ActualizacionNoviembre/fco-ranger-ficha-tecnica.pdf'),
				'RANGER XLS DIESEL': require('./../assets/Fichas/ActualizacionNoviembre/fco-ranger-ficha-tecnica.pdf'),
				'F-150 LARIAT SPORT': require('./../assets/Fichas/Nuevas/F150_HEV_BROCHURE_8sep.pdf'),
				'F-150 XLT FHEV': require('./../assets/Fichas/F150PlatinumHEV/F150_HEV_Brochure_30Jun_Optimizado.pdf'),
				'F-150 PLATINUM FHEV': require('./../assets/Fichas/F150PlatinumHEV/F150_HEV_Brochure_30Jun_Optimizado.pdf'),
				'RANGER RAPTOR': require('./../assets/Fichas/20. RANGER RAPTOR/fco-ranger-raptor-ficha-tecnica.pdf'),
				'F-150 RAPTOR': require('./../assets/Fichas/2023_05_12/f150raptor.pdf'),
				'RANGER FX4': require('./../assets/Fichas/2023_05_12/ranger.pdf'),
				'RANGER LIMITED': require('./../assets/Fichas/2023_05_12/ranger.pdf'),
				'RANGER LIMITED BLACK EDITION': require('./../assets/Fichas/2023_05_12/ranger.pdf'),
				'RANGER XL CHASIS': require('./../assets/Fichas/2023_05_12/ranger.pdf'),
				'RANGER XLT': require('./../assets/Fichas/2023_05_12/ranger.pdf'),
			},
		];
	},
};
